/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Hook_Authenticated_ActionInputs */

const en_onboarding_v1_hook_authenticated_action = /** @type {(inputs: Onboarding_V1_Hook_Authenticated_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue to Glider`)
};

const de_onboarding_v1_hook_authenticated_action = /** @type {(inputs: Onboarding_V1_Hook_Authenticated_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter zu Glider`)
};

const pt_br2_onboarding_v1_hook_authenticated_action = /** @type {(inputs: Onboarding_V1_Hook_Authenticated_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar no Glider`)
};

const tr_onboarding_v1_hook_authenticated_action = /** @type {(inputs: Onboarding_V1_Hook_Authenticated_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider'a devam et`)
};

const zh_cn2_onboarding_v1_hook_authenticated_action = /** @type {(inputs: Onboarding_V1_Hook_Authenticated_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续前往 Glider`)
};

const zh_hk2_onboarding_v1_hook_authenticated_action = /** @type {(inputs: Onboarding_V1_Hook_Authenticated_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繼續前往 Glider`)
};

const ko_kr2_onboarding_v1_hook_authenticated_action = /** @type {(inputs: Onboarding_V1_Hook_Authenticated_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider로 계속하기`)
};

const ru_ru2_onboarding_v1_hook_authenticated_action = /** @type {(inputs: Onboarding_V1_Hook_Authenticated_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти в Glider`)
};

const es_419_onboarding_v1_hook_authenticated_action = /** @type {(inputs: Onboarding_V1_Hook_Authenticated_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar en Glider`)
};

/**
* | output |
* | --- |
* | "Continue to Glider" |
*
* @param {Onboarding_V1_Hook_Authenticated_ActionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_hook_authenticated_action = /** @type {((inputs?: Onboarding_V1_Hook_Authenticated_ActionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Hook_Authenticated_ActionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_hook_authenticated_action(inputs)
	if (locale === "de") return de_onboarding_v1_hook_authenticated_action(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_hook_authenticated_action(inputs)
	if (locale === "tr") return tr_onboarding_v1_hook_authenticated_action(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_hook_authenticated_action(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_hook_authenticated_action(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_hook_authenticated_action(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_hook_authenticated_action(inputs)
	return es_419_onboarding_v1_hook_authenticated_action(inputs)
});